import { createContext, useState, useEffect } from "react";

export const UserContext = createContext({});

export function UserContextProvider({ children }) {
  const [userInfo, setUserInfo] = useState(null); // Start with null for unauthenticated users
  const [profileLoading, setProfileLoading] = useState(false); // Loading state
  const [profileError, setProfileError] = useState(null); // Error state

  const fetchUserProfile = async () => {
    setProfileLoading(true); // Start loading
    try {
      const response = await fetch(`${process.env.REACT_APP_API_END_POINT}/profile`, {
        credentials: 'include', // Ensure cookies (token) are sent
      });

      if (response.ok) {
        const data = await response.json();
        setUserInfo(data); // Set user info if authenticated
      } else if (response.status === 401) {
        setUserInfo(null); // Set to null if unauthorized
        // setProfileError('Unauthorized: No token provided'); 
      } else {
        // setProfileError('Failed to fetch profile'); 
      }
    } catch (error) {
      setProfileError('Failed to fetch profile');
    } finally {
      setProfileLoading(false); // End loading
    }
  };

  useEffect(() => {
    fetchUserProfile(); // Fetch the user profile when component mounts
  }, []);

  return (
    <UserContext.Provider value={{ userInfo, setUserInfo, profileLoading, profileError, fetchUserProfile }}>
      {children}
    </UserContext.Provider>
  );
}
